import { render, staticRenderFns } from "./ManualOverwriteLiveness.vue?vue&type=template&id=3b81ad2f"
import script from "./ManualOverwriteLiveness.vue?vue&type=script&lang=js"
export * from "./ManualOverwriteLiveness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports